// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2o0LZ","col":"CardReaderDesc_col__bkG-L","label":"CardReaderDesc_label__189JL"};